import { Banner } from '@cloudflare/kumo'
import { useTranslation } from '../../i18n'
import { formatDateTime } from '../../lib/format'
import { printerReachability } from '../../lib/printerConnection'

interface Props {
  epsonConnected: boolean | null
  connectionCheckedAt: string | null
  lastSeenConnectedAt: string | null
}

/**
 * Warns (never blocks) before a job goes to an offline printer. Renders
 * nothing unless the last probe is recent AND negative, so an unknown or
 * stale status never raises a false alarm.
 */
export function PrinterOfflineBanner({
  epsonConnected,
  connectionCheckedAt,
  lastSeenConnectedAt,
}: Props) {
  const { t } = useTranslation()
  if (printerReachability(epsonConnected, connectionCheckedAt) !== 'offline') return null
  return (
    <Banner variant="alert" className="mb-3" data-testid="printer-offline-banner">
      <strong>{t('print.offline.title')}</strong> {t('print.offline.body')}{' '}
      {lastSeenConnectedAt
        ? t('print.offline.lastSeen', { when: formatDateTime(lastSeenConnectedAt) })
        : t('print.offline.neverSeen')}
    </Banner>
  )
}
